export const SSO_USER_SIGN_IN = "SSO_USER_SIGN_IN";
export const SSO_USER_SIGN_OUT = "SSO_USER_SIGN_OUT";
export const SSO_USER_SIGN_UP = "SSO_USER_SIGN_UP";
export const SSO_USER_RESET_PASSWORD_REQUEST = "SSO_USER_RESET_PASSWORD_REQUEST";
export const SSO_USER_RESET_PASSWORD = "SSO_USER_RESET_PASSWORD";
export const SET_USER_EMAIL_DATA = "SET_USER_EMAIL_DATA";
export const SSO_SET_INDIVIDUAL_DATA = "SSO_SET_INDIVIDUAL_DATA";